import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ExclamationCircleOutlinedStandard.js";
import l from "../components/PfIcon.js";
const t = (r, a) => {
  const e = {
    ...r,
    ...a.attrs
  };
  return i(l, n(e, {
    icon: o
  }), null);
};
t.displayName = "ExclamationCircleOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
